import { LogLevel } from '@azure/msal-browser';
import { getDataverseEnvironmentUrl, getDataverseScope } from './config/dataverse';
import { environment, getEntraAuthority } from './config/environment';

const dataverseUrl = getDataverseEnvironmentUrl();

function getAuthRedirectUri() {
  if (typeof window !== 'undefined') {
    // Always return to the running origin in the browser so a stale
    // REACT_APP_REDIRECT_URI (e.g. :3001 while app is on :3002) cannot hang login.
    return window.location.origin;
  }

  return process.env.REACT_APP_REDIRECT_URI || undefined;
}

/** APIM / Unloc — own API app, never mix with Dataverse `/.default`. */
export const UNLOC_API_APP_ID = '54f412e1-8081-476b-b7cd-3149ab4d1de1';
export const UNLOC_API_ID_URI = 'api://opencare-unloc';

export function getUnlocApiScope() {
  return process.env.REACT_APP_UNLOC_API_SCOPE || `${UNLOC_API_ID_URI}/Unloc.Access`;
}

export function getUnlocScopes() {
  return {
    scopes: [getUnlocApiScope()]
  };
}

export const unlocScopes = getUnlocScopes();

export const msalConfig = {
  auth: {
    clientId: environment.entraClientId,
    authority: getEntraAuthority(),
    redirectUri: getAuthRedirectUri(),
    postLogoutRedirectUri:
      process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || getAuthRedirectUri()
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      }
    },
    allowNativeBroker: false,
    allowRedirectInIframe: true
  }
};

export function getLoginRequest() {
  return {
    // Kun Graph/OIDC her — Unloc er egen resource (api://opencare-unloc) og
    // hentes separat via getUnlocAccessToken (MSAL tillater ikke flere resources i ett token-kall).
    scopes: ['User.Read', 'openid', 'profile', 'email'],
    prompt: 'select_account'
  };
}

export const loginRequest = getLoginRequest();

export const logoutRequest = {
  postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || window.location.origin
};

export const dataverseScopes = {
  scopes: [getDataverseScope(dataverseUrl)]
};

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};

export const graphRequest = {
  scopes: ['User.Read']
};
